import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MenuHeaderTopic } from './menu-header.model';

@Component({
  selector: 'menu-header',
  templateUrl: './menu-header.component.html',
  styleUrl: './menu-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuHeaderComponent {
  @Input() menuTopic!: MenuHeaderTopic;
}
